module.exports = __webpack_public_path__ + "static/media/mir.36d868de.png";